import type Phaser from 'phaser';
import { PALETTE, FONT, px } from '../theme';
import { MIN_HIT } from './layout';
import { onTap } from './tap';

/**
 * Schlichte Schaltflaeche im Seekarten-Stil: eine duenne Umrandung, die beim
 * Ueberfahren aufhellt. Bewusst ohne Grafik-Assets, damit der Look sich in
 * einem Schritt aendern laesst.
 */
export function createButton(
  scene: Phaser.Scene,
  x: number,
  y: number,
  label: string,
  onClick: () => void,
  options: { width?: number; height?: number; fontSize?: number } = {},
): Phaser.GameObjects.Container {
  const fontSize = options.fontSize ?? 15;

  // Den Text zuerst anlegen und dann den Rahmen darum bauen. Andersherum —
  // feste Breite, Text hinein — stand die Beschriftung ueber dem Rand, sobald
  // die Schriftgroesse hochgestellt war. Die angegebene Breite ist deshalb
  // eine Untergrenze, keine Vorgabe.
  const text = scene.add
    .text(0, 0, label, {
      fontFamily: FONT.mono,
      fontSize: px(fontSize),
      color: PALETTE.inkDim,
    })
    .setOrigin(0.5);

  const width = Math.max(options.width ?? 200, text.width + 28);
  // Nie flacher als eine Fingerkuppe — auch wenn der Aufrufer weniger bestellt.
  const height = Math.max(options.height ?? 42, text.height + 14, MIN_HIT);

  const frame = scene.add.rectangle(0, 0, width, height, PALETTE.panel);
  frame.setStrokeStyle(1, PALETTE.panelEdge);

  const container = scene.add.container(x, y, [frame, text]);
  // Die tatsaechliche Breite muss ablesbar sein: Leisten, die mehrere
  // Schaltflaechen nebeneinander setzen, rechnen damit.
  container.setSize(width, height);
  container.setInteractive({ useHandCursor: true });

  onTap(container, {
    onTap: onClick,
    onHighlight: (on) => {
      frame.setStrokeStyle(1, on ? PALETTE.coast : PALETTE.panelEdge);
      text.setColor(on ? PALETTE.ink : PALETTE.inkDim);
    },
  });
  // Ein kurzes Einsinken beim Druecken — die Rueckmeldung, die ein Finger
  // ohne Hover sonst nicht bekommt.
  container.on('pointerdown', () => frame.setFillStyle(PALETTE.panelEdge));
  container.on('pointerup', () => frame.setFillStyle(PALETTE.panel));
  container.on('pointerout', () => frame.setFillStyle(PALETTE.panel));

  return container;
}
